// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"956fa89d","897":"103f2e54"}[chunkId] + ".chunk.js";
};